export default {
    dependencies: ['$element', 'radio', 'trackingservice'],
    callable(element, radio, trackingservice) {
        let searchResultCount;
        let uuid;
        let searchVersion;

        init();

        function trackClickOnAd(el) {
            const listPosition = el.getAttribute('data-listposition');
            const context = FINN.analytics.prepareContext().context;
            const ad = eleToResult(el);
            const selectedAdIdWithPrefix = findIdWithPrefix(ad);
            const resultType = getResultType(ad);
            const url = new URL(document.baseURI);
            trackingservice.trackLaterObj({
                ecType: 'SEARCH',
                ecCategory: 'search_result_www.ad.click',
                eventData: {
                    'search.fullurl': context.fullurl,
                    'search.searchresultcount': searchResultCount,
                    'search.resultListLayout': context.resultListLayout,
                    'search.userid': context.userid,
                    'search.searchterm': extractQuery(url),
                    'search.timestamp': Date.now(),
                    'search.uuid': uuid,
                    'search.resultType': resultType,
                    'search.listposition': listPosition,
                    'search.currentTimeSinceFas': context.currentTimeSinceFas,
                    'search.currentTimeSinceFrontpage':
                        context.currentTimeSinceFrontpage,
                },
                analyticsName: 'search.listpos.click',
                numberValue: listPosition,
                eventFlags: '',
                context: {
                    list1: selectedAdIdWithPrefix,
                    searchterm: url.searchParams.get('q') || '',
                    finnkode: el.getAttribute('id'),
                },
            });
        }

        function eleToResult(el) {
            return {
                adId: el.getAttribute('id'),
                promoted: el.hasAttribute('data-anypromoted'),
                bapWebStore: el.hasAttribute('data-bapwebstore'),
            };
        }

        function setSearchData(hits, visibleAds) {
            const url = new URL(document.baseURI);
            trackingservice.setContextForCurrentPageTracking({
                searchterm: url.searchParams.get('q') || '',
                searchresult: hits,
                list1: visibleAds,
            });
        }

        function getResultType(ad) {
            if (isPromotedAd(ad)) {
                return 'promoted';
            } else if (isNativeAd(ad)) {
                return 'native';
            } else {
                return 'organic';
            }
        }

        function isPromotedAd(ad) {
            return ad.promoted || ad.vipPromoted || ad.calendarPromoted;
        }

        function isNativeAd(ad) {
            return ad.bapWebStore;
        }

        function findPrefix(ad) {
            if (isPromotedAd(ad)) {
                return 'o_';
            } else if (isNativeAd(ad)) {
                return 'n_';
            }
            return 'f_';
        }

        function findIdWithPrefix(ad) {
            return findPrefix(ad) + ad.adId;
        }

        function visibleAdIds(results) {
            return results.filter(ad => ad.adId).map(findIdWithPrefix);
        }

        function init() {
            searchResultCount =
                element.getAttribute('data-result-hit-count') || '';
            uuid = element.getAttribute('data-search-uuid') || '';
            searchVersion = element.getAttribute('data-search-version') || '';

            const results = [
                ...element.querySelectorAll('[data-search-resultitem]'),
            ].map(eleToResult);
            const visibleAds = visibleAdIds(results);

            // Set context for page event on trackingservice init
            setSearchData(searchResultCount, visibleAds);
            trackSearchToEventCollector();

            element.addEventListener('click', event => {
                const ele = event.target.closest('[data-search-resultitem]');
                if (ele && event.currentTarget.contains(ele)) {
                    trackClickOnAd(ele);
                }
            });

            radio('filter-and-search-changed').subscribe(result => {
                searchResultCount = result.hits;
                uuid = result.uuid;
                searchVersion = result.searchVersion || '';

                setSearchData(
                    searchResultCount,
                    visibleAdIds(result.displaySearchResults)
                );
                const eventObj = Object.assign(
                    {},
                    getPulseTrackingData(result)
                );
                trackingservice.trackCurrentPage(eventObj);

                trackSearchToEventCollector();
            });
        }

        function trackSearchToEventCollector() {
            trackingservice.getApi(api => {
                const context = api.prepareContext().context;
                const url = new URL(document.baseURI);
                trackingservice.trackEventObject({
                    ecType: 'SEARCH',
                    ecCategory: 'search_result_www.fas.click',
                    eventData: {
                        'search.fullurl': context.fullurl,
                        'search.searchresultcount': searchResultCount,
                        'search.resultListLayout': context.resultListLayout,
                        'search.userid': context.userid,
                        'search.searchterm': extractQuery(url),
                        'search.timestamp': Date.now(),
                        'search.uuid': uuid,
                        'search.version': searchVersion,
                    },
                });
            });
        }

        function getPulseTrackingData(result) {
            const url = new URL(document.baseURI);
            const query = extractQuery(url);
            const sorting = extractSort(result);

            const filters = {};
            if (query) {
                filters.query = query;
            }
            if (sorting) {
                filters.sorting = sorting;
            }
            filters.numResults = String(result.hits);

            return {
                context: {
                    filters,
                },
            };
        }

        function extractQuery(url) {
            return url.searchParams.get('q') || '';
        }

        function extractSort(result) {
            return result.sortValues
                .filter(sortValue => sortValue.selected)
                .map(sortValue => translateSortToSptEnum(sortValue))
                .find(sortValue => sortValue);
        }

        function translateSortToSptEnum(sortValue) {
            const sortDescription = sortValue.description.toLocaleLowerCase();
            if (sortDescription.includes('relevant')) {
                return 'Relevance';
            } else if (sortDescription.includes('publisert')) {
                return 'PublishedTime';
            } else {
                return 'Other';
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/searchResultTracking.js